<template>
  <div id="product-page" v-if="webstoreContent">
    <ProductSubNav
      :globals="webstoreContent.webstoreBody"
      :productContent="content"
      :isSticky="productNavIsSticky"
      @clicked="setTab"
      @change-active-page="changeActivePage"
    />
    <transition name="fade">
      <ProductOverviewTab
        v-if="activeProductTab === 'overview'"
        :content="content"
        @clicked="setTab"
      />
    </transition>
    <transition name="fade">
      <ProductFeatureTab
        v-if="activeProductTab === 'features'"
        key="features"
        :product="content.features"
        :globals="webstoreContent.webstoreBody"
        :length="featureLength"
        :title="content.featuresHeader"
        :group="content.features"
        :activeProduct="activeProductInfo"
        class="roboto"
      >
        <LicenseModule
          v-if="webstoreContent.webstoreBody.license && activeProductKey.includes('CM')"
          :content="webstoreContent.webstoreBody.license"
          class="roboto"
        />
      </ProductFeatureTab>
    </transition>
    <transition name="fade">
      <ProductFeatureTab
        v-if="activeProductTab === 'specs'"
        key="specs"
        :product="content.specs"
        :globals="webstoreContent.webstoreBody"
        :length="specLength"
        :specs="true"
        :title="content.specsHeader"
        :group="content.specs"
        :activeProduct="activeProductInfo"
        class="roboto"
      />
    </transition>
    <transition name="fade">
      <AddToCartTab
        v-if="activeProductTab === 'buy'"
        ref="addToCart"
        :submitButtonText="submitButtonText"
        :addToCartDisabled="addToCartDisabled"
        :bottomNavIsShown="bottomNavIsShown"
        @add-to-cart="cartUpdateHandler($event)"
        @handle-scroll="handleScroll"
      />
    </transition>
    <CMModal
      :isOpen="isModalVisible"
      @cm-add-to-cart="cmAddToCart"
      @hide-modal="hideModal()"
      :globals="webstoreContent.webstoreBody"
      :showCM31="showCM31"
      :showCM32="showCM32"
    />
    <InquireModal
      :isOpen="inquireModalIsOpen"
      @hide-modal="inquireModalIsOpen = false"
    />
    <AnonymousInquiryModal v-if="inquireAnonymousModalIsOpen" @hide-modal='inquireAnonymousModalIsOpen = false'/>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";

import { UpdateShoppingCartHandlers } from "../../../mixins/update-shopping-cart-handlers";
import ScrollToTop from "../../../mixins/scrollToTop";
import ErrorStateIcon from "../../utils/error-state-icon";
import ProductFeatureTab from "./components/ProductFeatureTab";
import ProductOverviewTab from "./components/ProductOverviewTab";
import AddToCartTab from "./components/AddToCartTab";
import ProductSubNav from "./components/ProductSubNav";
import AddtoBagNav from "./components/AddtoBagNav";
import LicenseModule from "./components/LicenseModule";
import CMModal from './components/CMModal';
import InquireModal from './inquire-modal'
import product from '../../../store/modules/product/index';
import { analyticsTrack } from "../../../plugins/segment";
import { WebstoreResources } from "../../../mixins/webstore-resources";
import AnonymousInquiryModal from './AnonymousInquiryModal.vue'

export default {

  props: ['webstoreProductContent'],

  mixins: [
    UpdateShoppingCartHandlers,
    ScrollToTop,
    WebstoreResources
  ],

  components: {
    ErrorStateIcon,
    LicenseModule,
    ProductFeatureTab,
    ProductOverviewTab,
    AddToCartTab,
    ProductSubNav,
    AddtoBagNav,
    CMModal,
    InquireModal,
    AnonymousInquiryModal
  },

  data() {
    return {
      threeColumnMaxOfferingLength: 18,
      isPageDataFetched: false,
      bagStepScroll: {},
      showSticky: false,
      productNavIsSticky: false,
      isModalVisible: false,
      bottomNavIsShown: true,
      inquireModalIsOpen: false,
      inquireAnonymousModalIsOpen: false,
      showCM31: false,
      showCM32: false,
    };
  },

  computed: {

    selectOfferHeaderText() {
      return this.isProductWithCableOptions
        ? this.webstoreContent.selectProductsPage.select_cable_type
        : this.webstoreContent.selectProductsPage.select_purchase_type;
    },

    cableDataFromOfferInCart() {
      return this.existingOfferInCart ? this.existingOfferInCart.cables : [];
    },

    isProductWithCableOptions() {
      return (
        this.activeProductKey === "ACC-PB" ||
        this.activeProductKey.includes("CBL")
      );
    },

    addToCartDisabled() {
      if (this.activeOffer.productStatus === 'Out of Stock') {
        return true;
      } else if (!this.doesOfferRequireCable(this.activeOfferKey) && this.bagStep > 0) {
        return false;
      } else if ((this.cablesSelectedCount === this.cablesNeededCount) && this.bagStep > 2) {
        return false;
      } else if ((this.cablesSelectedCount === this.cablesNeededCount) && (!this.displayVehicleCableSelectionOptions && this.bagStep > 1)) {
        return false;
      } else {
        return true;
      }
    },

    content() {
      return this.webstoreProductContent.productOrder.filter(
        (product) => product.fields.key === this.activeProductInfo.key
      )[0].fields;
    },

    featureLength() {
      return this.content.features ? this.content.features.length : "";
    },

    specLength() {
      return this.content.specs ? this.content.specs.length : "";
    },
  },

  methods: {
    ...mapMutations([
      "setActiveOfferKey",
      "setActiveProductFamilyInactive",
      "setActiveProductKeyInactive",
      "setActiveOfferKeyInactive",
      "setShoppingCartToOpened",
      "setActiveProductTab",
      "setActiveProductTabDefault",
      "setBagStep"
    ]),

    ...mapActions("content", ["getWebstoreGlobals"]),

    setActiveProduct() {
        this.setActiveProductKey(this.productKey);
        this.setActiveProductFamily(this.productFamily);
    },

    handleScroll() {
      // // Show Sticky button for mobile
      // if (this.$refs['addToBag'] && (window.scrollY > (this.$refs['addToBag'].$el.offsetHeight - 15))) {
      //   this.showSticky = true;
      // } else {
      //   this.showSticky = false;
      // }

      // Handle the sticky navbar
      this.productNavIsSticky = (window.scrollY > 81);
    },

    hideModal() {
      this.isModalVisible = false;
      document.body.style.position = '';
    },

    cartUpdateHandler() {
      this.updateCart();
    },

    cmAddToCart(cmOffer) {
      if (this.findExistingOfferInCart(cmOffer.productKey, cmOffer.offerKey)) {
        this.updateSelectedOfferQuantityHandler(
          cmOffer,
          this.$store.getters[`${cmOffer.productKey}/quantity`],
          {}
        );
      } else {
        this.addOfferToProductsInCartHandler(
          cmOffer,
          this.$store.getters[`${cmOffer.productKey}/quantity`],
          {}
        );
      }
    },

    transformMMYSubmittedStringToList(offerKey) {
      let transformedMmyData = [];
      let offerSubmittedMMYData = this.$store.getters[
        `${this.activeProductKey}${offerKey}CableSelection/mmy/submittedMMYData`
      ];
      let mmyRowKeys = [];
      if (this.activeProductKey === "AG26") {
        mmyRowKeys = [
          "assetType",
          "trailerType",
          "diagnosticsCoverage",
          "make",
          "model",
          "year",
          "diagnosticsPortType",
          "quantity",
          "productId",
        ];
      } else {
        if (this.displayNACableSelection) {
          mmyRowKeys = [
            "make",
            "vehicleType",
            "model",
            "year",
            "quantity",
            "productId",
          ];
        } else {
          mmyRowKeys = [
            "make",
            "vehicleType",
            "year",
            "quantity",
            "remoteTacho",
            "FMSGateway",
          ];
        }
      }
      for (let cable in offerSubmittedMMYData) {
        let mmyData = {};
        for (let key of mmyRowKeys) {
          mmyData[key] =
            key in offerSubmittedMMYData[cable].originalPayload
              ? offerSubmittedMMYData[cable].originalPayload[key]
              : "";
        }
        transformedMmyData.push(mmyData);
      }
      return transformedMmyData;
    },

    transformVinSubmittedKeysToString(offerKey) {
      let transformedVinData = "";
      let offerSubmittedVinData = this.$store.getters[
        `${this.activeProductKey}${offerKey}CableSelection/vin/submittedVinData`
      ];
      for (let cable in offerSubmittedVinData) {
        transformedVinData += `${offerSubmittedVinData[cable].customerInput}\n`;
      }
      return transformedVinData;
    },
  },

  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (
        [
          "shoppingCart/updateSelectedOfferQuantity",
          "shoppingCart/addOfferToProductsInCart",
        ].includes(mutation.type) && (!['VG54'].includes(this.activeProductKey) || !this.activeOffer.offerType.includes('Fleet'))
      ) {
        this.productAddedToCart()
      }
    });

    this.setActiveOfferKey(this.activeOffer ? this.activeOffer.offerKey : this.activeProductInfo.defaultOffering);

    if (!this.$store.getters[`${this.productKeyOverride ? this.productKeyOverride : this.activeProductKey}/quantity`]) {
      this.$store.registerModule(`${this.productKeyOverride ? this.productKeyOverride : this.activeProductKey}`, product)
    }
  },

  mounted() {
    // when using $watch + string interpolation, square Array brackets are not interpreted correctly by Vue, remove them
    // for (let ref in this.$refs) {
    //   this.$refs[ref] = this.$refs[ref][0];
    // }

    setTimeout(() => {
      // Handle Cable selection store method registration
      for (let offerName in this.activeProductInfo.offerings) {
        let offer = this.activeProductInfo.offerings[offerName];
        let offerInCart = this.isOfferInCart(offer);
        if (this.doesOfferRequireCable(offer.offerKey)) {
          if (!offerInCart) {
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/vin/clearVinData`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/manualSelection/clearManualSelectionData`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/mmy/clearMMYData`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/vin/clearSubmittedVinData`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/mmy/clearSubmittedMMYData`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/base/setCablesNeededCount`,
              1
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/base/setCablesSelectedCount`
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/base/setTotalCablesSubmittedData`
            );
          } else {
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/vin/setSubmittedVinData`,
              offerInCart.cables.filter((data) => data.type === "vin")
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/mmy/setSubmittedMMYData`,
              offerInCart.cables.filter((data) => data.type === "mmy")
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/manualSelection/setManualSelectionData`,
              offerInCart.cables
                .filter((data) => data.type === "manualSelection")
                .reduce((obj, cable) => {
                  obj[cable.cable] = cable.quantity;
                  return obj;
                }, {})
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/vin/setVinData`,
              this.transformVinSubmittedKeysToString(offer.offerKey)
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/mmy/setMMYData`,
              this.transformMMYSubmittedStringToList(offer.offerKey)
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/base/setCablesNeededCount`,
              offerInCart.quantity
            );
            this.$store.commit(
              `${this.activeProductKey}${offer.offerKey}CableSelection/base/setCablesSelectedCount`
            );
            this.$store.commit(
              `${this.activeProductKey}${this.activeOfferKey}CableSelection/base/setTotalCablesSubmittedData`
            );
          }
        }
      }
    }, 0);

    window.addEventListener('scroll', this.handleScroll)

    analyticsTrack("Offer Selected", {
      offer: this.activeOffer.offerKey,
      productKey: this.activeProductKey,
    });
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<style lang="scss" scoped>

li:focus,
button:focus {
  outline: none;
  box-shadow: 0 0 4px #0d6ede;
}

#product-page {
  font-family: "Roboto", sans-serif !important;
  font-style: normal;
  font-weight: normal;
  -webkit-animation: fadeIn 1s;
  animation: fadeIn 1s;
  white-space: initial !important;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* Add animation (fade in the popup) */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
  from {
    visibility: hidden;
  }
  to {
    visibility: visible;
  }
}

#cable-guide {
  color: unset;
  text-decoration: underline;
}

#product-status {
  color: red;
}

.active {
  border: 3px solid #0384fb;
}

#included {
  min-height: 190px;
}

#add-product-button-container {
  width: auto;
  min-width: 200px;
}

#cables-submitted-count {
  font-size: 24px;
  font-weight: bold;
}

#cables-still-required {
  color: #ee6917;
}

#all-cables-selected {
  color: #0db010;
}

@media only screen and (max-width: 999px) {
  #product-image {
    display: flex;
    justify-content: center;
  }
  #add-product-button-container {
    padding-right: 0px;
  }
}

.roboto {
  font-family: "Roboto", Helvetica, sans-serif !important;
}
</style>
